// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2dsSo","range":"MonthRangeSwitch_range__31qT7","disabled":"MonthRangeSwitch_disabled__3yaMF"};